import { CommonHitterAvatar } from 'components/common/hitters/avatar';
import { HitterSideBadge } from 'components/common/hitters/hitter-side-badge';
import { t } from 'i18next';
import { IOptionExt } from 'interfaces/forms/option-ext';
import { HITTER_SIDES_DICT } from 'lib_ts/enums/hitters.enums';
import { IHitter } from 'lib_ts/interfaces/i-hitter';
import { compact } from 'lodash';

export const getHitterOption = (
  h: IHitter,
  group?: string,
  options?: {
    hidePrefix?: boolean;
    hideSuffix?: boolean;
  }
): IOptionExt => {
  const sideLabel = HITTER_SIDES_DICT[h.side]?.label;

  const o: IOptionExt = {
    label: h.name,
    value: h._id,
    group: group,
    suffixLabel: sideLabel ? t(sideLabel).toString() : undefined,
    suffix: options?.hideSuffix ? undefined : (
      <HitterSideBadge value={h.side} />
    ),
    prefix: options?.hidePrefix ? undefined : (
      <CommonHitterAvatar size="1" hitter={h} clickDisabled />
    ),
    aliases: compact([h._mx_phone, h._mx_phone?.replace(/\D/g, '')]), // allow searching by phone number
  };

  return o;
};
